import { createEnv } from "@t3-oss/env-nextjs";
import { vercel } from "@t3-oss/env-nextjs/presets";
import { z } from "zod";

export const env = createEnv({
  extends: [vercel()],
  skipValidation:
    !!process.env.SKIP_ENV_VALIDATION &&
    process.env.SKIP_ENV_VALIDATION !== "false" &&
    process.env.SKIP_ENV_VALIDATION !== "0",
  server: {
    ANALYZE: z.coerce.boolean().optional().default(false),
    ASSET_TRIAGE_SERVICE_URL: z.string().url().default("http://localhost:3007"),
    API_KEY_PEPPER: z.string().optional(),
    AUTO_REPORT_THREAT_SCAN_RESULTS_MINUTES: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(60),
    CHAINPATROL_ADMIN_NOTIFICATION_EMAILS: z.string().optional(),
    CHAINPATROL_API_KEY: z.string().optional(),
    CLOUDFLARE_TURNSTILE_SECRET_KEY: z.string().optional(),
    CLOUDFLARE_R2_ACCESS_KEY_ID: z.string().optional(),
    CLOUDFLARE_R2_SECRET_ACCESS_KEY: z.string().optional(),
    DATABASE_URL: z.string().url().default("http://localhost:5432"),
    DATABASE_REPLICA_URL: z.string().url().default("http://localhost:5432"),
    DISCORD_CLIENT_ID: z.string().optional(),
    DISCORD_CLIENT_SECRET: z.string().optional(),
    DISCORD_OAUTH_URL: z.string().optional(),
    EMAIL_FROM: z.string().optional().default("ChainPatrol <no-reply@chainpatrol.io>"),
    EMAIL_HOST: z.string().optional(),
    EMAIL_PASS: z.string().optional(),
    EMAIL_PORT: z.string().optional(),
    EMAIL_USER: z.string().optional(),
    ETH_PHISHING_DETECT_SERVER_URL: z.string().optional(),
    TRANCO_LIST_SERVER_URL: z.string().optional(),
    POLKADOT_PHISHING_SERVER_URL: z.string().optional(),
    GITHUB_ACCESS_TOKEN: z.string().optional(),
    CHAINPATROL_GITHUB_APP_ID: z.string().optional(),
    CHAINPATROL_GITHUB_PRIVATE_KEY: z.string().optional(),
    GOOGLE_APPLICATION_CREDENTIALS: z.string().optional(),
    GOOGLE_SAFEBROWSING_PROJECT_ID: z.string().optional(),
    GOOGLE_WEB_RISK_API_KEY: z.string().optional(),
    GOOGLE_CHAT_WEBHOOK_URL: z.string().url().optional(),
    INNGEST_EVENT_KEY: z.string().optional(),
    INNGEST_SIGNING_KEY_FALLBACK: z.string().optional(),
    INNGEST_SIGNING_KEY: z.string().optional(),
    KNOCK_API_KEY: z.string().optional(),
    KNOCK_DISCORD_CHANNEL_ID: z.string().optional(),
    KNOCK_SLACK_CHANNEL_ID: z.string().optional(),
    METABASE_SECRET_KEY: z.string().optional(),
    METABASE_SITE_URL: z.string().optional(),
    NEXTAUTH_SECRET: z.string().optional(),
    NEXTAUTH_URL: z.string().url().optional(),
    OPENAI_API_KEY: z.string().optional(),
    GOOGLE_GENERATIVE_AI_API_KEY: z.string().optional(),
    PAGERDUTY_DISPUTE_INTEGRATION_KEY: z.string().optional(),
    PAGERDUTY_NEW_REPORT_INTEGRATION_KEY: z.string().optional(),
    PORT: z.coerce.number().int().positive().optional(),
    POSTHOG_API_KEY: z.string().optional(),
    RAILWAY_ENVIRONMENT: z.string().optional(),
    SEALISAC_API_KEY: z.string().optional(),
    SEALISAC_CHAINPATROL_ORG_ID: z.string().optional(),
    BROWSERBASE_API_KEY: z.string().optional(),
    BROWSERBASE_PROJECT_ID: z.string().optional(),
    SLACK_APP_ID: z.string().optional(),
    SLACK_OAUTH_URL: z.string().optional(),
    SLACK_ALERTS_EMAIL: z.string().optional(),
    SOCIALDATA_TOOLS_API_KEY: z.string().optional(),
    TEMPORAL_ADDRESS: z.string().optional().default("localhost:7233"),
    TELEGRAM_BOT_TOKEN: z.string().optional(),
    TEMPORAL_NAMESPACE: z.string().default("default"),
    TEMPORAL_API_KEY: z.string().optional(),
    TIME_TO_REVERT_PROPOSAL_REVIEW_SECONDS: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(60),
    TWITTER_BEARER_TOKEN: z.string().optional(),
    TWITTER_API_KEY: z.string().optional(),
    TWITTER_API_KEY_SECRET: z.string().optional(),
    TWITTER_ACCESS_TOKEN: z.string().optional(),
    TWITTER_ACCESS_TOKEN_SECRET: z.string().optional(),
    URLSCAN_API_KEY: z.string().optional(),
    URLSCAN_HOURS: z.number().int().positive().optional(),
    UPLOADIO_SECRET_API_KEY: z.string().optional(),
    GLOBAL_GUEST_RATE_LIMIT_DURATION: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(60),
    GLOBAL_GUEST_RATE_LIMIT_LIMIT: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(100),
    GLOBAL_AUTHED_RATE_LIMIT_DURATION: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(60),
    GLOBAL_AUTHED_RATE_LIMIT_LIMIT: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(250),
    GLOBAL_AUTOMATION_RATE_LIMIT_DURATION: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(60),
    GLOBAL_AUTOMATION_RATE_LIMIT_LIMIT: z.coerce
      .number()
      .int()
      .positive()
      .optional()
      .default(500),
    MEDIUM_TAKEDOWNS_GOOGLE_ACCOUNT_EMAIL: z.string().optional(),
    MEDIUM_TAKEDOWNS_GOOGLE_ACCOUNT_PASSWORD: z.string().optional(),
    MEDIUM_TAKEDOWNS_ACCOUNT_EMAIL: z.string().optional(),
    POSTMARK_SERVER_TOKEN: z.string().optional(),
    CLOUDFLARE_ACCOUNT_ID: z.string().optional(),
    CLOUDFLARE_REPORTING_API_TOKEN: z.string().optional(),
    VERCEL_TEAM_ID: z.string().optional(),
    VERCEL_API_TOKEN: z.string().optional(),
    GODADDY_API_KEY: z.string().optional(),
    GODADDY_API_SECRET: z.string().optional(),
    TELEGRAM_API_ID: z.coerce.number().int().positive().optional(),
    TELEGRAM_API_HASH: z.string().optional(),
    UPLOADIO_TWITTER_PROFILE_IMAGE_API_KEY: z.string().optional(),
    INTERCOM_CLIENT_ID: z.string().optional(),
    INTERCOM_CLIENT_SECRET: z.string().optional(),
    MOZILLA_ADDON_SECRET_KEY: z.string().optional(),
    MOZILLA_ADDON_USER_ID: z.string().optional(),
    GOOGLE_CHAT_WEBHOOK_URL_TRANCO_LIST_BYPASSED: z.string().url().optional(),
    OPEN_PAGE_RANK_API_KEY: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_UPLOADIO_API_KEY: z.string().optional(),
    NEXT_PUBLIC_UPLOADIO_PRIVATE_API_KEY: z.string().optional(),
    NEXT_PUBLIC_UPLOADIO_ACCOUNT_ID: z.string().optional(),
    NEXT_PUBLIC_VERCEL_URL: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_PROJECT_ID: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_PERSONAL_API_KEY: z.string().optional(),
  },
  runtimeEnv: {
    ANALYZE: process.env.ANALYZE,
    ASSET_TRIAGE_SERVICE_URL: process.env.ASSET_TRIAGE_SERVICE_URL,
    API_KEY_PEPPER: process.env.API_KEY_PEPPER,
    AUTO_REPORT_THREAT_SCAN_RESULTS_MINUTES:
      process.env.AUTO_REPORT_THREAT_SCAN_RESULTS_MINUTES,
    CLOUDFLARE_TURNSTILE_SECRET_KEY: process.env.CLOUDFLARE_TURNSTILE_SECRET_KEY,
    CHAINPATROL_API_KEY: process.env.CHAINPATROL_API_KEY,
    CLOUDFLARE_R2_ACCESS_KEY_ID: process.env.CLOUDFLARE_R2_ACCESS_KEY_ID,
    CLOUDFLARE_R2_SECRET_ACCESS_KEY: process.env.CLOUDFLARE_R2_SECRET_ACCESS_KEY,
    CHAINPATROL_ADMIN_NOTIFICATION_EMAILS:
      process.env.CHAINPATROL_ADMIN_NOTIFICATION_EMAILS,
    DATABASE_URL: process.env.DATABASE_URL,
    DATABASE_REPLICA_URL: process.env.DATABASE_REPLICA_URL,
    DISCORD_CLIENT_ID: process.env.DISCORD_CLIENT_ID,
    DISCORD_CLIENT_SECRET: process.env.DISCORD_CLIENT_SECRET,
    DISCORD_OAUTH_URL: process.env.DISCORD_OAUTH_URL,
    EMAIL_FROM: process.env.EMAIL_FROM,
    EMAIL_HOST: process.env.EMAIL_HOST,
    EMAIL_PASS: process.env.EMAIL_PASS,
    EMAIL_PORT: process.env.EMAIL_PORT,
    EMAIL_USER: process.env.EMAIL_USER,
    ETH_PHISHING_DETECT_SERVER_URL: process.env.ETH_PHISHING_DETECT_SERVER_URL,
    TRANCO_LIST_SERVER_URL: process.env.TRANCO_LIST_SERVER_URL,
    POLKADOT_PHISHING_SERVER_URL: process.env.POLKADOT_PHISHING_SERVER_URL,
    GITHUB_ACCESS_TOKEN: process.env.GITHUB_ACCESS_TOKEN,
    CHAINPATROL_GITHUB_APP_ID: process.env.CHAINPATROL_GITHUB_APP_ID,
    CHAINPATROL_GITHUB_PRIVATE_KEY: process.env.CHAINPATROL_GITHUB_PRIVATE_KEY,
    GOOGLE_APPLICATION_CREDENTIALS: process.env.GOOGLE_APPLICATION_CREDENTIALS,
    GOOGLE_SAFEBROWSING_PROJECT_ID: process.env.GOOGLE_SAFEBROWSING_PROJECT_ID,
    GOOGLE_WEB_RISK_API_KEY: process.env.GOOGLE_WEB_RISK_API_KEY,
    GOOGLE_CHAT_WEBHOOK_URL: process.env.GOOGLE_CHAT_WEBHOOK_URL,
    INNGEST_EVENT_KEY: process.env.INNGEST_EVENT_KEY,
    INNGEST_SIGNING_KEY: process.env.INNGEST_SIGNING_KEY,
    INNGEST_SIGNING_KEY_FALLBACK: process.env.INNGEST_SIGNING_KEY_FALLBACK,
    KNOCK_API_KEY: process.env.KNOCK_API_KEY,
    KNOCK_DISCORD_CHANNEL_ID: process.env.KNOCK_DISCORD_CHANNEL_ID,
    KNOCK_SLACK_CHANNEL_ID: process.env.KNOCK_SLACK_CHANNEL_ID,
    METABASE_SECRET_KEY: process.env.METABASE_SECRET_KEY,
    METABASE_SITE_URL: process.env.METABASE_SITE_URL,
    NEXT_PUBLIC_UPLOADIO_API_KEY: process.env.NEXT_PUBLIC_UPLOADIO_API_KEY,
    NEXT_PUBLIC_UPLOADIO_ACCOUNT_ID: process.env.NEXT_PUBLIC_UPLOADIO_ACCOUNT_ID,
    NEXT_PUBLIC_VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
    NEXT_PUBLIC_POSTHOG_API_KEY: process.env.NEXT_PUBLIC_POSTHOG_API_KEY,
    NEXT_PUBLIC_POSTHOG_PERSONAL_API_KEY:
      process.env.NEXT_PUBLIC_POSTHOG_PERSONAL_API_KEY,
    NEXT_PUBLIC_POSTHOG_PROJECT_ID: process.env.NEXT_PUBLIC_POSTHOG_PROJECT_ID,
    NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
    NEXTAUTH_URL: process.env.NEXTAUTH_URL,
    OPENAI_API_KEY: process.env.OPENAI_API_KEY,
    GOOGLE_GENERATIVE_AI_API_KEY: process.env.GOOGLE_GENERATIVE_AI_API_KEY,
    PAGERDUTY_DISPUTE_INTEGRATION_KEY: process.env.PAGERDUTY_DISPUTE_INTEGRATION_KEY,
    PAGERDUTY_NEW_REPORT_INTEGRATION_KEY:
      process.env.PAGERDUTY_NEW_REPORT_INTEGRATION_KEY,
    PORT: process.env.PORT,
    POSTHOG_API_KEY: process.env.POSTHOG_API_KEY,
    RAILWAY_ENVIRONMENT: process.env.RAILWAY_ENVIRONMENT,
    SEALISAC_API_KEY: process.env.SEALISAC_API_KEY,
    SEALISAC_CHAINPATROL_ORG_ID: process.env.SEALISAC_CHAINPATROL_ORG_ID,
    BROWSERBASE_API_KEY: process.env.BROWSERBASE_API_KEY,
    BROWSERBASE_PROJECT_ID: process.env.BROWSERBASE_PROJECT_ID,
    SLACK_APP_ID: process.env.SLACK_APP_ID,
    SLACK_OAUTH_URL: process.env.SLACK_OAUTH_URL,
    SLACK_ALERTS_EMAIL: process.env.SLACK_ALERTS_EMAIL,
    SOCIALDATA_TOOLS_API_KEY: process.env.SOCIALDATA_TOOLS_API_KEY,
    TELEGRAM_BOT_TOKEN: process.env.TELEGRAM_BOT_TOKEN,
    TEMPORAL_ADDRESS: process.env.TEMPORAL_ADDRESS,
    TEMPORAL_NAMESPACE: process.env.TEMPORAL_NAMESPACE,
    TEMPORAL_API_KEY: process.env.TEMPORAL_API_KEY,
    TIME_TO_REVERT_PROPOSAL_REVIEW_SECONDS:
      process.env.TIME_TO_REVERT_PROPOSAL_REVIEW_SECONDS,
    TWITTER_BEARER_TOKEN: process.env.TWITTER_BEARER_TOKEN,
    TWITTER_API_KEY: process.env.TWITTER_API_KEY,
    TWITTER_API_KEY_SECRET: process.env.TWITTER_API_KEY_SECRET,
    TWITTER_ACCESS_TOKEN: process.env.TWITTER_ACCESS_TOKEN,
    TWITTER_ACCESS_TOKEN_SECRET: process.env.TWITTER_ACCESS_TOKEN_SECRET,
    URLSCAN_API_KEY: process.env.URLSCAN_API_KEY,
    URLSCAN_HOURS: process.env.URLSCAN_HOURS,
    UPLOADIO_SECRET_API_KEY: process.env.UPLOADIO_SECRET_API_KEY,
    NEXT_PUBLIC_UPLOADIO_PRIVATE_API_KEY:
      process.env.NEXT_PUBLIC_UPLOADIO_PRIVATE_API_KEY,
    MEDIUM_TAKEDOWNS_GOOGLE_ACCOUNT_EMAIL:
      process.env.MEDIUM_TAKEDOWNS_GOOGLE_ACCOUNT_EMAIL,
    MEDIUM_TAKEDOWNS_GOOGLE_ACCOUNT_PASSWORD:
      process.env.MEDIUM_TAKEDOWNS_GOOGLE_ACCOUNT_PASSWORD,
    GLOBAL_GUEST_RATE_LIMIT_DURATION: process.env.GLOBAL_GUEST_RATE_LIMIT_DURATION,
    GLOBAL_GUEST_RATE_LIMIT_LIMIT: process.env.GLOBAL_GUEST_RATE_LIMIT_LIMIT,
    GLOBAL_AUTHED_RATE_LIMIT_DURATION: process.env.GLOBAL_AUTHED_RATE_LIMIT_DURATION,
    GLOBAL_AUTHED_RATE_LIMIT_LIMIT: process.env.GLOBAL_AUTHED_RATE_LIMIT_LIMIT,
    GLOBAL_AUTOMATION_RATE_LIMIT_DURATION:
      process.env.GLOBAL_AUTOMATION_RATE_LIMIT_DURATION,
    GLOBAL_AUTOMATION_RATE_LIMIT_LIMIT: process.env.GLOBAL_AUTOMATION_RATE_LIMIT_LIMIT,
    MEDIUM_TAKEDOWNS_ACCOUNT_EMAIL: process.env.MEDIUM_TAKEDOWNS_ACCOUNT_EMAIL,
    POSTMARK_SERVER_TOKEN: process.env.POSTMARK_SERVER_TOKEN,
    CLOUDFLARE_ACCOUNT_ID: process.env.CLOUDFLARE_ACCOUNT_ID,
    CLOUDFLARE_REPORTING_API_TOKEN: process.env.CLOUDFLARE_REPORTING_API_TOKEN,
    VERCEL_TEAM_ID: process.env.VERCEL_TEAM_ID,
    VERCEL_API_TOKEN: process.env.VERCEL_API_TOKEN,
    GODADDY_API_KEY: process.env.GODADDY_API_KEY,
    GODADDY_API_SECRET: process.env.GODADDY_API_SECRET,
    TELEGRAM_API_ID: process.env.TELEGRAM_API_ID,
    TELEGRAM_API_HASH: process.env.TELEGRAM_API_HASH,
    UPLOADIO_TWITTER_PROFILE_IMAGE_API_KEY:
      process.env.UPLOADIO_TWITTER_PROFILE_IMAGE_API_KEY,
    INTERCOM_CLIENT_ID: process.env.INTERCOM_CLIENT_ID,
    INTERCOM_CLIENT_SECRET: process.env.INTERCOM_CLIENT_SECRET,
    MOZILLA_ADDON_SECRET_KEY: process.env.MOZILLA_ADDON_SECRET_KEY,
    MOZILLA_ADDON_USER_ID: process.env.MOZILLA_ADDON_USER_ID,
    GOOGLE_CHAT_WEBHOOK_URL_TRANCO_LIST_BYPASSED:
      process.env.GOOGLE_CHAT_WEBHOOK_URL_TRANCO_LIST_BYPASSED,
    OPEN_PAGE_RANK_API_KEY: process.env.OPEN_PAGE_RANK_API_KEY,
  },
});
